document.addEventListener("DOMContentLoaded", function () {
  // This script handles the "load more" functionality for review sections on the page.
  // There are two modes:
  // 1. "paginate": New review items are fetched from the server in batches (pagination).
  // 2. "preload": All review items are already in the DOM but only a subset is visible initially; clicking reveals more.
  document.querySelectorAll<HTMLElement>(".ratings_section").forEach((section) => {
    // Get the loading mode from the data attribute (e.g., "paginate" or "preload")
    const loadMode = section.dataset.loadMode;

    // Find the "load more" button within the section
    const loadMoreBtn = section.querySelector<HTMLButtonElement>(".load-more-btn");
    if (!loadMoreBtn) return; // Exit if no button found

    if (loadMode === "paginate") {
      // PAGINATE MODE: Fetch new reviews from the server when the button is clicked

      // Attach a click event listener to the "load more" button
      loadMoreBtn.addEventListener("click", function () {
        // Retrieve the next page number from the button's data attribute (defaulting to 0 if not set)
        let nextPage = parseInt(loadMoreBtn.dataset.nextPage || "0", 10);

        // Get necessary IDs from the section's data attributes
        const serviceProviderId = section.dataset.serviceProviderId;
        const semCategoryId = section.dataset.semCategoryId;

        // Find the container where the reviews are displayed
        const ratingsContainer = section.querySelector(".ratings-container");

        // If any required data is missing, exit the function
        if (!serviceProviderId || !semCategoryId || !ratingsContainer) return;

        // Build the URL for fetching evaluations with pagination parameters
        // The offset is calculated by multiplying the current page number by the number of reviews per page (3)
        const url = `/service_providers/${serviceProviderId}/evaluations?sem_category=${semCategoryId}&limit=3&offset=${nextPage * 3}`;

        console.log("Fetching URL: ", url);

        // Fetch data from the constructed URL
        fetch(url)
            .then((response) => response.text()) // HTML response
            .then((html) => {
              // Check if the returned HTML content is not empty
              if (html.trim() !== "") {
                // Append the new reviews to the ratings container
                ratingsContainer.insertAdjacentHTML("beforeend", html);
                // Increment the page counter and update the button's data attribute
                nextPage++;
                loadMoreBtn.dataset.nextPage = nextPage.toString();
              }

              // If no more reviews are returned, hide the load more button
              if (html.trim() === "") {
                loadMoreBtn.style.display = "none";
              }
            })
            .catch((error) => console.error("Error loading more evaluations:", error));
      });
    } else {
      // PRELOAD MODE: All reviews are already on the page but only a few are shown initially.
      // More reviews are revealed in batches on clicking the "load more" button.

      // Select all review items within the section
      const reviews = section.querySelectorAll<HTMLElement>(".rating-item");
      // Define the number of reviews to show initially (and the increment per click)
      let visibleCount = 3;

      // Add a click event listener to the "load more" button to reveal more reviews
      loadMoreBtn.addEventListener("click", function () {
        // Loop through the next batch of reviews and set their display to "block" (visible)
        for (let i = visibleCount; i < visibleCount + 3 && i < reviews.length; i++) {
          reviews[i].style.display = "block";
        }
        // Increase the count of visible reviews by 3
        visibleCount += 3;

        // If all reviews are now visible, hide the "load more" button
        if (visibleCount >= reviews.length) {
          loadMoreBtn.style.display = "none";
        }
      });

      // If the initial visible count is already equal to or exceeds the total reviews,
      // hide the "load more" button immediately.
      if (visibleCount >= reviews.length) {
        loadMoreBtn.style.display = "none";
      }
    }
  });


  // Truncates comments to 250 characters and toggles between full and truncated text on button click.
  document.querySelectorAll(".sp-profile .see-more-rating-body-btn").forEach((button) => {
    const commentText = button.previousElementSibling as HTMLElement; // Type assertion here
    const fullComment = commentText.dataset.fullComment;

    // Initialize state for truncated comment
    commentText.dataset.truncated = "true";
    commentText.textContent = fullComment.substring(0, 250) + "...";

    button.addEventListener("click", () => {
      const isTruncated = commentText.dataset.truncated === "true";

      // Typecast button to HTMLElement to access dataset properties
      const buttonElement = button as HTMLElement;
      // Toggle comment text and button text
      commentText.textContent = isTruncated ? fullComment : fullComment.substring(0, 250) + "...";
      buttonElement.textContent = isTruncated ? buttonElement.dataset.less : buttonElement.dataset.more;
      commentText.dataset.truncated = isTruncated ? "false" : "true";
    });
  });

  // Initialize Swiper
  if (window.Swiper && window.Mousewheel) { // ✅ Check if Mousewheel exists
    new window.Swiper(".sp_profile_portfolio_swiper", {
      direction: "horizontal",
      slidesPerView: "auto",
      spaceBetween: 10,
      mousewheel: {
        forceToAxis: true, // Ensures scrolling only affects Swiper
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      modules: [window.Mousewheel], // ✅ Use window.Mousewheel instead of Mousewheel
    });

    new window.Swiper(".sp_profile_similars_sp", {
      slidesPerView: 'auto',
      spaceBetween: 15,
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 25,
        }
      },
    });
  } else {
    console.error("Swiper or Mousewheel is not defined. Ensure they are properly loaded.");
  }


  // Function to handle the "Ask an Offer" button click
  // This function is triggered when the user clicks the button to ask for an offer.
  // It attempts to find the corresponding iframe for the conversation ID and sends a message to it.
  // If the iframe is found and the message is sent successfully, a success message is displayed.
  // Otherwise, an error message is shown to the user.
  document.addEventListener('click', (event) => {
    const target = event.target as HTMLElement;
    if (target.matches("[data-ask-an-offer-action='ask-an-offer']")) {
      askForOffersendMessageToIframe(target);
    }
  });

  function askForOffersendMessageToIframe(button: HTMLElement) {
    const conversationId = button.getAttribute('data-conversation-id');
    const message = button.getAttribute('data-ask-an-offer-message');
    const successMessage = button.getAttribute('data-ask-an-offer-success-message');
    const errorMessage = button.getAttribute('data-ask-an-offer-error-message');

    if (!conversationId || !message || !successMessage || !errorMessage) {
      console.error('❌ Missing attributes on the button.');
      return;
    }

    // Find all buttons with the same conversation ID
    const allMatchingButtons = document.querySelectorAll(`button[data-conversation-id="${conversationId}"]`);

    // Try to find the correct iframe based on conversation ID
    const iframe = document.querySelector(`iframe[src*='/conversations/${conversationId}']`) as HTMLIFrameElement | null;

    if (!iframe) {
      console.error('❌ Iframe not found for conversation ID: ' + conversationId);
      askAnOfferdisplayMessage(conversationId, errorMessage, 'danger', button);
      return;
    }

    function sendMessage() {
      if (!iframe.contentWindow) {
        console.error('❌ Iframe contentWindow not accessible for conversation ID: ' + conversationId);
        askAnOfferdisplayMessage(conversationId, errorMessage, 'danger', button);
        return;
      }

      console.log('✅ Sending message to iframe with conversation ID: ' + conversationId);
      iframe.contentWindow.postMessage({
        type: 'ask_offer_button',
        conversationId: conversationId,
        message: message
      }, '*');

      askAnOfferdisplayMessage(conversationId, successMessage, 'success', button);

      // Disable all matching buttons (profile & conversation offcanvas)
      allMatchingButtons.forEach((btn) => {
        btn.setAttribute('disabled', 'true');
      });
    }

    if (iframe.contentWindow && iframe.contentWindow.document.readyState === 'complete') {
      sendMessage();
    } else {
      iframe.onload = sendMessage;
    }
  }

  // Function to display the success or error message below the button
  function askAnOfferdisplayMessage(conversationId, message, messageType, button) {
    // Create a new div for the message dynamically
    const messageDiv = document.createElement('div');
    messageDiv.classList.add('text-center', 'mt-3', 'w-100', 'text-sm');

    // Add appropriate Bootstrap class based on success or error
    //messageDiv.classList.add('text-' + messageType);
    messageDiv.innerHTML = message;  // Use innerHTML to render the HTML inside the message

    // Insert the message div below the button
    button.parentElement.insertBefore(messageDiv, button.nextSibling); // Inserts the message below the button
  }
});
